import styled from 'styled-components'
/* Flex definitions -- start -- */
interface FlexProps {
    direction?: 'row' | 'column'
    justifyContent?: 'flex-start' | 'flex-end' | 'center' | 'space-between'
    flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse'
    fillParent?: boolean
}

export const Flex = styled.div<FlexProps>`
    display: flex;
    flex-direction: ${props => props.direction};
    flex-wrap: ${props => props.flexWrap};
    justify-content: ${props => props.justifyContent};
    height: ${props => (props.fillParent ? '100%' : null)};
    width: 100%;
`
/* Flex definitions -- end -- */

export const Title = styled.text`
    margin-left: 6px;
    line-height: 16px;
    color: ${({ theme }) => theme['gray-800']};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 13px;
`

export const Select = styled.select`
    font-family: ${({ theme }) => theme['font-regular']};
    background: ${({ theme }) => theme['gray-0']};
    -webkit-appearance: none;
    border: 1px solid ${({ theme }) => theme['gray-500']};
    box-sizing: border-box;
    width: 100%;
    height: 100%;
`

export const Option = styled.option`
    height: 100%;
    font-family: ${({ theme }) => theme['font-regular']};
    font-size: 7%;
    text-indent: 2%;
`

export const MainTitle = styled.text`
    color: ${({ theme }) => theme['gray-800']};
    font-family: ${({ theme }) => theme['font-semibold']};
    font-size: 100%;
    line-height: 16px;
    margin-bottom: -1%;
`

export const Icon = styled.i``
